import { render, staticRenderFns } from "./prepare-records.vue?vue&type=template&id=70f678d8&scoped=true"
import script from "./prepare-records.vue?vue&type=script&lang=js"
export * from "./prepare-records.vue?vue&type=script&lang=js"
import style0 from "./prepare-records.vue?vue&type=style&index=0&id=70f678d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f678d8",
  null
  
)

export default component.exports